/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';
import { uniqueId } from 'lodash';
import { Ellipsis, PaginationItem } from 'view/molecules/PaginationComponents';
import { CONFIG_PAGINATION } from '../Pagination.model';

type IPaginationHelperParams = {
  countPages: number;
  currentPage: number;
  changeCurrentPage?: (n: number) => void;
  config?: CONFIG_PAGINATION;
  setConfig?: (conf: CONFIG_PAGINATION) => void;
};

export const computeConfig = ({
  countPages,
  currentPage,
  setConfig,
}: IPaginationHelperParams) => {
  if (setConfig)
    if (countPages < 6) {
      setConfig(CONFIG_PAGINATION.first);
    } else if (currentPage < 3) {
      setConfig(CONFIG_PAGINATION.second);
    } else if (currentPage === 3) {
      setConfig(CONFIG_PAGINATION.third);
    } else if (currentPage === countPages - 2) {
      setConfig(CONFIG_PAGINATION.fifth);
    } else if (currentPage > countPages - 2) {
      setConfig(CONFIG_PAGINATION.sixth);
    } else {
      setConfig(CONFIG_PAGINATION.fourth);
    }
};

export const createNavigateManager = ({
  countPages,
  currentPage,
  changeCurrentPage = (_) => {},
}: IPaginationHelperParams) => ({
  goToFirst: () => {
    currentPage !== 1 && changeCurrentPage(1);
  },
  goToLast: () => {
    currentPage !== countPages && changeCurrentPage(countPages);
  },
  goToPrev: () => {
    currentPage !== 1 && changeCurrentPage(currentPage - 1);
  },
  goToNext: () => {
    currentPage !== countPages && changeCurrentPage(currentPage + 1);
  },
});

export const createContentPart = ({
  countPages,
  currentPage,
  changeCurrentPage = (_) => {},
  config,
}: IPaginationHelperParams) => {
  switch (config) {
    case CONFIG_PAGINATION.first: {
      return (
        <>
          {[...Array(countPages)].map((_, index) => (
            <PaginationItem
              active={index + 1 === currentPage}
              changeCurrentPage={changeCurrentPage}
              index={index + 1}
              key={uniqueId()}
            />
          ))}
        </>
      );
    }
    case CONFIG_PAGINATION.second:
    case CONFIG_PAGINATION.third: {
      return (
        <>
          {[1, 2, 3].map((item) => (
            <PaginationItem
              active={item === currentPage}
              changeCurrentPage={changeCurrentPage}
              index={item}
              key={item}
            />
          ))}
        </>
      );
    }
    case CONFIG_PAGINATION.fifth:
    case CONFIG_PAGINATION.sixth: {
      return (
        <>
          {[countPages - 3, countPages - 2, countPages - 1, countPages].map(
            (item) => (
              <PaginationItem
                active={item === currentPage}
                changeCurrentPage={changeCurrentPage}
                index={item}
                key={item}
              />
            ),
          )}
        </>
      );
    }
    default:
      return (
        <>
          {[currentPage - 1, currentPage, currentPage + 1].map((item) => (
            <PaginationItem
              active={item === currentPage}
              changeCurrentPage={changeCurrentPage}
              index={item}
              key={item}
            />
          ))}
        </>
      );
  }
};

export const createSpecialPart = ({
  countPages,
  currentPage,
  changeCurrentPage = (_) => {},
  config,
}: IPaginationHelperParams) => {
  switch (config) {
    case CONFIG_PAGINATION.second: {
      return (
        <>
          <Ellipsis />
          <PaginationItem
            active={false}
            changeCurrentPage={changeCurrentPage}
            index={countPages}
          />
        </>
      );
    }
    case CONFIG_PAGINATION.third: {
      return (
        <>
          <PaginationItem
            active={false}
            changeCurrentPage={changeCurrentPage}
            index={currentPage + 1}
          />
          <Ellipsis />
        </>
      );
    }
    case CONFIG_PAGINATION.fifth: {
      return <Ellipsis />;
    }
    case CONFIG_PAGINATION.sixth: {
      return <Ellipsis />;
    }
    default: {
      return <Ellipsis />;
    }
  }
};
